// extracted by mini-css-extract-plugin
export default {"root":"root___eyaDb","numbers":"numbers___IDTcJ","button":"button___lIuB5","link":"link___P_nwF","active":"active___CLunP","prev":"prev___9LsYJ","next":"next____QZgM"};